import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import LoadingScreen from '@/components/LoadingScreen';

export default function LogoutPage() {
  const { logout } = useAuth0();

  useEffect(() => {
    // Trigger logout immediately when this component mounts
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }, [logout]);

  // Show loading screen while logout is processing
  return <LoadingScreen />;
}
